import { render, staticRenderFns } from "./wgy.vue?vue&type=template&id=0f463288&scoped=true&"
import script from "./wgy.vue?vue&type=script&lang=js&"
export * from "./wgy.vue?vue&type=script&lang=js&"
import style0 from "./wgy.vue?vue&type=style&index=0&id=0f463288&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f463288",
  null
  
)

export default component.exports